<template>
  <div id="componente-card">
    <div class="w3-row w3-margin-bottom">
      <div class="w3-col s12">
        <div class="w3-white w3-block">
          <slot></slot>
          <hr>
        </div><!-- w3-white -->
      </div><!-- w3-col -->
    </div><!-- w3-row -->
  </div><!-- componente-card -->
</template>

<script>
  export default {
    name: 'ComponenteCard',

    props: ['tituloComponenteCard',  'mobile', 'icone'],

    methods: {
      fecharComponente() {
        this.$emit('fecharComponente');
      },

      getClasseComponenteCard() {
        if(this.mobile === true) {
          return 'w3-hide-large w3-medium';
        }
        else {
          return 'w3-hide-mobile';
        }
      },
    },

    mounted() {
      $('html,body').stop().animate(
        {scrollTop: 0},
        'slow',
        'swing'
      );
    }
  }
</script>

<style scoped>
  .icone-card-title {
    font-size: 2em;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
</style>


// WEBPACK FOOTER //
// src/components/ComponenteCard.vue